import { NgModule } from '@angular/core';
import { AuthModule, OpenIdConfiguration, StsConfigLoader, StsConfigStaticLoader } from 'angular-auth-oidc-client'; 
import { ConfigService } from '../config/config-service';

const authFactory = (configService: ConfigService) => {
  const config = configService.getConfig('identity');
  return new StsConfigStaticLoader(config as OpenIdConfiguration);
};

@NgModule({
  imports: [AuthModule.forRoot({
    loader: {
        provide: StsConfigLoader,
        useFactory: authFactory,
        deps: [ConfigService],
      },
  })],
  exports: [AuthModule]
})
export class AuthConfigModule { }
